import Stack from '@mui/material/Stack'
import Link from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'

/** Titles stay English — they name English-language legal documents, like COD/POS (§10). */
const LEGAL_LINKS = [
  { slug: 'terms', label: 'Terms & Conditions' },
  { slug: 'privacy', label: 'Privacy Policy' },
  { slug: 'refunds', label: 'Refund & Cancellation' },
  { slug: 'shipping', label: 'Shipping & Delivery' },
]

/**
 * The policy links a payment-gateway auditor clicks through. Rendered on every storefront page
 * and on both sign-in screens. The `/legal/*` routes live in the storefront shell, so a click
 * from the owner console leaves the console — intended: they are the public shop's documents.
 */
export default function LegalFooter({ sx }: { sx?: object }) {
  return (
    <Stack
      component="nav"
      direction="row"
      spacing={2}
      useFlexGap
      flexWrap="wrap"
      justifyContent="center"
      sx={{ mt: 1.5, color: 'text.secondary', ...sx }}
    >
      {LEGAL_LINKS.map((link) => (
        <Link
          key={link.slug}
          component={RouterLink}
          to={`/legal/${link.slug}`}
          variant="body2"
          color="inherit"
          underline="hover"
        >
          {link.label}
        </Link>
      ))}
    </Stack>
  )
}
